import { DefaultBlock } from 'components/common-form/builder/form/node/block/DefaultBlock';
import { PopoverBlock } from 'components/common-form/builder/form/node/block/PopoverBlock';
import { ScheduleFooterBlock } from 'components/common-form/builder/form/node/block/ScheduleFooterBlock';
import { ScheduleTopBarBlock } from 'components/common-form/builder/form/node/block/ScheduleTopBarBlock';
import { TabsBlock } from 'components/common-form/builder/form/node/block/TabsBlock';
import { AdjustablePercentField } from 'components/common-form/builder/form/node/field/AdjustablePercentField';
import { AmountField } from 'components/common-form/builder/form/node/field/AmountField';
import { BatchDealSplitModalField } from 'components/common-form/builder/form/node/field/BatchDealSplitModalField';
import { BatchLockablePercentField } from 'components/common-form/builder/form/node/field/BatchLockablePercentField';
import { BatchMultipleUnderlyingsField } from 'components/common-form/builder/form/node/field/BatchMultipleUnderlyingsField/BatchMultipleUnderlyingsField';
import { BatchScheduleModalField } from 'components/common-form/builder/form/node/field/BatchScheduleModalField';
import { BatchToggleField } from 'components/common-form/builder/form/node/field/BatchToggleField/BatchToggleField';
import { BlankField } from 'components/common-form/builder/form/node/field/BlankField';
import { CashFlowField } from 'components/common-form/builder/form/node/field/CashFlowField';
import { ClientListField } from 'components/common-form/builder/form/node/field/ClientListField';
import { CorrelationTableField } from 'components/common-form/builder/form/node/field/CorrelationTableField';
import { CurrencyListField } from 'components/common-form/builder/form/node/field/CurrencyListField';
import { CurrencyPairSwitcherField } from 'components/common-form/builder/form/node/field/CurrencyPairSwitcherField';
import { DateField } from 'components/common-form/builder/form/node/field/DateField';
import { DateLabelField } from 'components/common-form/builder/form/node/field/DateLabelField';
import { DatesListField } from 'components/common-form/builder/form/node/field/DatesListField';
import { DatesRangeField } from 'components/common-form/builder/form/node/field/DatesRangeField';
import { DealSplitField } from 'components/common-form/builder/form/node/field/DealSplit/DealSplitField';
import { DoubleValuationGridField } from 'components/common-form/builder/form/node/field/DoubleValuationGrid/GridField';
import { GraphModalField } from 'components/common-form/builder/form/node/field/GraphModalField/GraphModalField';
import { ExportGridButton } from 'components/common-form/builder/form/node/field/Grid/ExportGridButton';
import { GridField } from 'components/common-form/builder/form/node/field/Grid/GridField';
import { IntWithUnitsField } from 'components/common-form/builder/form/node/field/IntWithUnitsField';
import { JointLineScatterChartField } from 'components/common-form/builder/form/node/field/JointLineScatterChartField';
import { LabelField } from 'components/common-form/builder/form/node/field/LabelField/LabelField';
import { ListField } from 'components/common-form/builder/form/node/field/ListField';
import { LockableAmountField } from 'components/common-form/builder/form/node/field/LockableAmountField/LockableAmountField';
import { LockablePercentField } from 'components/common-form/builder/form/node/field/LockablePercentField';
import { MultipleApplyBatchMultipleUnderlyingsField } from 'components/common-form/builder/form/node/field/MultipleApply/MultipleApplyBatchMultipleUnderlyingsField';
import { MultipleApplyBatchSingleUnderlyingField } from 'components/common-form/builder/form/node/field/MultipleApply/MultipleApplyBatchSingleUnderlyingField';
import { MultipleApplyClientListField } from 'components/common-form/builder/form/node/field/MultipleApply/MultipleApplyClientListField';
import { MultipleApplyLockablePercentField } from 'components/common-form/builder/form/node/field/MultipleApply/MultipleApplyLockablePercentField';
import { BatchMultipleApplyToggleField } from 'components/common-form/builder/form/node/field/MultipleApply/MultipleApplyToggleField';
import { MultipleBadgeField } from 'components/common-form/builder/form/node/field/MultipleBadgeField';
import { MultipleLabelField } from 'components/common-form/builder/form/node/field/MultipleLabelField';
import { MultipleUnderlyingsField } from 'components/common-form/builder/form/node/field/MultipleUnderlyingsField';
import { MultipleUnitsField } from 'components/common-form/builder/form/node/field/MultipleUnitsField';
import { MultiSelectField } from 'components/common-form/builder/form/node/field/MultiSelectField';
import { NumberField } from 'components/common-form/builder/form/node/field/NumberField';
import { PercentField } from 'components/common-form/builder/form/node/field/PercentField';
import { PresetDateField } from 'components/common-form/builder/form/node/field/PresetDateField';
import { ProductCodesGrid } from 'components/common-form/builder/form/node/field/ProductCodesGrid/ProductCodes';
import { RadioButtonsField } from 'components/common-form/builder/form/node/field/RadioButtonsField';
import { RealSingleUnderlyingField } from 'components/common-form/builder/form/node/field/RealSingleUnderlyingField';
import { SensitivitiesField } from 'components/common-form/builder/form/node/field/SensitivitiesField';
import { SaferSimpleGridField } from 'components/common-form/builder/form/node/field/SimpleGrid/SaferSimpleGridField';
import { SimpleGridField } from 'components/common-form/builder/form/node/field/SimpleGrid/SimpleGridField';
import { SingleCustodianDealSplitField } from 'components/common-form/builder/form/node/field/SingleCustodianDealSplitField';
import { SingleUnderlyingField } from 'components/common-form/builder/form/node/field/SingleUnderlyingField';
import { SpecificOrBlackoutDateField } from 'components/common-form/builder/form/node/field/SpecificOrBlackoutDateField';
import { VerticalSpotAndGreeks } from 'components/common-form/builder/form/node/field/SpotAndGreeksField/VerticalSpotAndGreeksField';
import { TenorField } from 'components/common-form/builder/form/node/field/TenorField';
import { TextField } from 'components/common-form/builder/form/node/field/TextField';
import { TimeSeriesGraphField } from 'components/common-form/builder/form/node/field/TimeSeriesGraphField';
import { ToggleFieldWrappedWithErrors } from 'components/common-form/builder/form/node/field/ToggleField';
import { UnderlyingsSearchField } from 'components/common-form/builder/form/node/field/UnderlyingsSearchField';
import { UnderlyingsStrikeField } from 'components/common-form/builder/form/node/field/UnderlyingsStrikeField';
import { UnknownField } from 'components/common-form/builder/form/node/field/UnknownField';
import type { FieldMetadata } from 'models/forms/fields';
import type { StaticProductView } from 'state/product-description/types';

import { DailyBlotter } from '../../../staticForm/components/dailyBlotter/DailyBlotter';
import { BatchExternalQuoteIdField } from './node/field/BatchExternalQuoteIdField';
import { BatchSingleUnderlyingField } from './node/field/BatchSingleUnderlyingsField';
import { CheckboxField } from './node/field/CheckboxField';
import { ClientLabelField } from './node/field/ClientLabelField';
import { ExternalQuoteIdField } from './node/field/ExternalQuoteIdField';
import { FeesAndMetricsField } from './node/field/FeesAndMetricsField';
import { NonRelevantField } from './node/field/NonRelevantField/NonRelevantField';
import { OrderedPickerField } from './node/field/OrderedPickerField';
import { SimpleGridFieldWithHeader } from './node/field/SimpleGrid/SimpleGridFieldWithHeader';
import { HorizontalSpotAndGreeks } from './node/field/SpotAndGreeksField/HorizontalSpotAndGreeks';
import { TimeSpanField } from './node/field/TimeSpanField';

function componentForTypeByMultipleApply(type: FieldMetadata['type']) {
  switch (type) {
    case 'ToggleField':
      return BatchMultipleApplyToggleField;
    case 'MultipleUnderlyingsField':
      return MultipleApplyBatchMultipleUnderlyingsField;
    case 'UnderlyingsField':
      return MultipleApplyBatchSingleUnderlyingField;
    case 'ClientListField':
      return MultipleApplyClientListField;
    case 'LockablePercentField':
      return MultipleApplyLockablePercentField;
    default:
      return undefined;
  }
}
export function componentForType(
  type: string,
  productView: StaticProductView,
  isMultipleApply: boolean,
  fieldMetadata: FieldMetadata | undefined,
) {
  if (isMultipleApply) {
    const component = componentForTypeByMultipleApply(type as FieldMetadata['type']);
    if (component) {
      return component;
    }
  }
  return getComponent(type, productView, fieldMetadata);
}
function getComponent(type: string, productView: StaticProductView, fieldMetadata: FieldMetadata | undefined) {
  if (productView === 'Batch' && fieldMetadata === undefined) {
    return NonRelevantField;
  }
  switch (type) {
    case 'Technical':
    case 'Client':
      return null;
    case 'Blank':
      return productView === 'Batch' ? NonRelevantField : BlankField;
    case 'ScheduleTopBar':
    case 'ScheduleModalTopBar':
      return ScheduleTopBarBlock;
    case 'ScheduleModalFooter':
      return ScheduleFooterBlock;
    case 'Popover':
      return PopoverBlock;
    case 'Default':
    case 'DefaultWithCount':
    case 'Feature':
      return DefaultBlock;
    case 'Column':
      return null;
    case 'Tabs':
      return TabsBlock;
    case 'HintListField':
    case 'ListField':
      return ListField;
    case 'CurrencyListField':
      return CurrencyListField;
    case 'CurrencyPairSwitcherField':
      return CurrencyPairSwitcherField;
    case 'RadioButtonsField':
      return RadioButtonsField;
    case 'LockablePercentField':
      return productView === 'Batch' ? BatchLockablePercentField : LockablePercentField;
    case 'PercentField':
      return PercentField;
    case 'MultipleUnitsField':
      return MultipleUnitsField;
    case 'AdjustablePercentField':
      return AdjustablePercentField;
    case 'AmountField':
      return AmountField;
    case 'LockableAmountField':
      return LockableAmountField;
    case 'LabelField':
      return LabelField;
    case 'DateLabelField':
      return DateLabelField;
    case 'ClientLabelField':
      return ClientLabelField;
    case 'ToggleField':
      return productView === 'Batch' ? BatchToggleField : ToggleFieldWrappedWithErrors;
    case 'CheckboxField':
      return CheckboxField;
    case 'OrderedPickerField':
      return OrderedPickerField;
    case 'MultiSelectField':
      return MultiSelectField;
    case 'TextField':
      return TextField;
    case 'ExternalQuoteIdField':
      return productView === 'Batch' ? BatchExternalQuoteIdField : ExternalQuoteIdField;
    case 'CustomizableTenorField':
      return TenorField;
    case 'DateField':
      return DateField;
    case 'PresetDateField':
      return PresetDateField;
    case 'NumberField':
      return NumberField;
    case 'ClientListField':
      return ClientListField;
    case 'SearchEditableField':
      return MultipleUnderlyingsField;
    case 'UnderlyingsSearch':
      return UnderlyingsSearchField;
    case 'SingleSearchEditableField':
      return SingleUnderlyingField;
    case 'SingleUnderlyingField':
      return RealSingleUnderlyingField;
    case 'UnderlyingsField':
      return BatchSingleUnderlyingField;
    case 'MultipleUnderlyingsField':
      return BatchMultipleUnderlyingsField;
    case 'SimpleGridField':
      return SimpleGridField;
    case 'SimpleGridFieldWithHeader':
      return SimpleGridFieldWithHeader;
    case 'SaferSimpleGridField':
      return SaferSimpleGridField;
    case 'GridWithoutPagination':
      return GridField;
    case 'ExportGridButton':
      return ExportGridButton;
    case 'DoubleValuationGridField':
      return DoubleValuationGridField;
    case 'DealSplitGrid':
      return DealSplitField;
    case 'DealSplitModalField':
      return productView === 'Batch' ? BatchDealSplitModalField : null;
    case 'ProductCodesGrid':
      return ProductCodesGrid;
    case 'MultipleLabelField':
      return MultipleLabelField;
    case 'MultipleBadgeField':
      return MultipleBadgeField;
    case 'JointLineScatterChartField':
      return JointLineScatterChartField;
    case 'CorrelationTableField':
      return CorrelationTableField;
    case 'DailyBlotter':
      return DailyBlotter;
    case 'DatesListField':
      return DatesListField;
    case 'DatesRangeField':
      return DatesRangeField;
    case 'SpotAndGreeksField':
      return VerticalSpotAndGreeks;
    case 'HorizontalSpotAndGreeksField':
      return HorizontalSpotAndGreeks;
    case 'FeesAndMetricsField':
      return FeesAndMetricsField;
    case 'SensitivitiesField':
      return SensitivitiesField;
    case 'TimeSpanField':
      return TimeSpanField;
    case 'UnderlyingsStrikeField':
      return UnderlyingsStrikeField;
    case 'SingleCustodianDealSplitField':
      return SingleCustodianDealSplitField;
    case 'CashFlowField':
      return CashFlowField;
    case 'ScheduleModalField':
      return productView === 'Batch' ? BatchScheduleModalField : null;
    case 'SpecificOrBlackoutDateField':
      return SpecificOrBlackoutDateField;
    case 'IntWithUnitsField':
      return IntWithUnitsField;
    case 'TimeSeriesGraphField':
      return TimeSeriesGraphField;
    case 'GraphModalField':
      return productView === 'Batch' ? GraphModalField : null;

    default:
      if (productView === 'Batch') {
        return NonRelevantField;
      } else if (productView === 'OrdersBasket') {
        return BlankField;
      } else {
        return UnknownField;
      }
  }
}
